export default "/site/aidive/js/react/dist/images/olympiacos-bg.7888c7cd.jpg";